import { RecursiveObject } from '@chakra-ui/react';

export const fonts: RecursiveObject<string> = {
  heading: `var(--satoshi), system-ui, sans-serif`,
  sourceCodePro: `var(--source-code-pro), system-ui, sans-serif`
};
